import {
    SET_APPROVERS_LIST,
    IS_OUT_OF_OFFICE_SAVED,
    SET_CURRENT_OOO_SETTINGS,
    IS_OUT_OF_OFFICE_SAVED_PROFILE,
    SET_CURRENT_OOO_SETTINGS_PROFILE,
    SET_VALIDATE_BACKUP_APPROVER
} from "./OutOfOfficeTypes";

const initialState = {
    currentOOOSettings : null,
    currentOOOSettingsProfile : null,
    approversList : {},
    isOutOfOfficeSaved : null,
    isOutOfOfficeSavedProfile : null,
    validateBackupApprover : null 
}

const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_APPROVERS_LIST:
            return {
                ...state,
                approversList: action.response,
            };
        case IS_OUT_OF_OFFICE_SAVED:
            return {
                ...state,
                isOutOfOfficeSaved: action.response,
            };
        case SET_CURRENT_OOO_SETTINGS:
            return {
                ...state,
                currentOOOSettings: action.response,
            };
        case IS_OUT_OF_OFFICE_SAVED_PROFILE:
            return {
                ...state,
                isOutOfOfficeSavedProfile: action.response,
            };
        case SET_CURRENT_OOO_SETTINGS_PROFILE:
            return {
                ...state,
                currentOOOSettingsProfile: action.response,
            }; 
        case SET_VALIDATE_BACKUP_APPROVER:
            return {
                ...state,
                validateBackupApprover: action.response,
            };   
        default:
            return state;
    }
};

export default reducer;